import { useCallback } from 'react';

export default function useShare() {
    const share = useCallback(async ({ title, text, url }) => {
        if (!url) return { success: false, method: 'failed' };
        if (navigator.share) {
            try {
                await navigator.share({ title, text, url });
                return { success: true, method: 'native' };
            } catch (error) {
                if (error.name === 'AbortError') {
                    return { success: false, method: 'cancelled' };
                }
                return { success: false, method: 'failed' };
            }
        }

        try {
            await navigator.clipboard.writeText(url);
            return { success: true, method: 'clipboard' };
        } catch (error) {
            console.error('Error copying to clipboard:', error);
            return { success: false, method: 'failed' };
        }
    }, []);

    return { share };
}
